//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'footerBuild',
  components:{},
  props: {
    
  },

  data () {
    return {
      offsetHeight:400,
      showWX:false,
      tHeight:0,
      isShowTop:false
    }
  },

  methods:{
    
    openNetWrite(){
      window.open("/iksnet_api/images/10-1P62FF009231.jpg")
    },
    openPlice(){
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025727")
    },
    openNetAcc(){
      window.open("/iksnet_api/images/10-1P62FA341357.jpg")
    },
    openICP(){
      window.open("https://beian.miit.gov.cn/")
    },
    openLink(url){
      window.open(url,'_blank')
    },
    openAccept(){
      window.open("https://ss.knet.cn/verifyseal.dll?sn=e13111511010043456nq0k000000&ct=df&a=1&pa=0.028054921654984355",'_blank')
    },
   
  },
  watch:{
    
  },
  mounted(){
    
  },
  destroyed() {
   
  },
}



// WEBPACK FOOTER //
// ./src/view/footerBuild.vue